import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/Resources/DemurrageAndDetention/components/SectionKey02/SectionKey02.module.scss';

const cn = classNames.bind(styles);

const SectionKey02 = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  const renderHeadingContentByScreenWidth = () => {
    if (screenWidth >= 769) {
      return (
        <>
          <span>Key Components</span>{' '}
          <span>of the OSRA 22 Final Rule 2024</span>
        </>
      );
    }
    if (screenWidth <= 769) {
      return (
        <>
          <span>Key Components</span>{' '}
          <span>of the OSRA 22 Final Rule</span>{' '}
          <span>2024</span>
        </>
      );
    }
  };

  return (
    <section className={cn('key-02')}>
      <div className={cn('container')}>

        <h2 className={cn('key-02__heading')}>
          {renderHeadingContentByScreenWidth()}
        </h2>

        <div className={cn('key-02__content')}>
          <ol className={cn('key-02__list')}>
            <li className={cn('key-02__list-item')}>
              Respond to Every Invoice and Settle Any Disagreements Within 30 Days
            </li>
            <li className={cn('key-02__list-item')}>
              Maintain Thorough Documentation for a Minimum of Five Years
              <ul className={cn('key-02__sublist')}>
                <li className={cn('key-02__sublist-item')}>
                  This supports adherence and conflict resolution.
                </li>
              </ul>
            </li>
            <li className={cn('key-02__list-item')}>
              Ensure Accurate Invoice Details
              <ul className={cn('key-02__sublist')}>
                <li className={cn('key-02__sublist-item')}>
                  Include container number, free days, rates, and contact information.
                </li>
              </ul>
            </li>
            <li className={cn('key-02__list-item')}>
              Utilize Visibility Tools
              <ul className={cn('key-02__sublist')}>
                <li className={cn('key-02__sublist-item')}>
                  Use tracking tools to keep abreast of the current status of all cargo, ensuring awareness of potential changes.
                </li>
              </ul>
            </li>
          </ol>

          <p className={cn('key-02__summary')}>
            By following these guidelines, stakeholders can ensure compliance with the OSRA 22
            final rule, leading to more efficient and transparent operations within the container
            logistics sector.
          </p>

        </div>
      </div>
    </section>
  );
};

export default SectionKey02;